import { createContext } from 'react';

import { LoyaltyBonusStore } from '../store';

export const StoreContext = createContext<LoyaltyBonusStore | null>(null);
